import { fromJS } from 'immutable';
import * as actionTypes from '../../constants/daySheetActionTypes';

const initialState = fromJS({
  list: [],
  isLoading: false,
});

export function daySheetTotalByDayOfWeekReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_DS_TOTAL_BY_DAY_OF_WEEK: {
      return state.set('list', fromJS(action.payload));
    }
    case actionTypes.GET_DS_TOTAL_BY_DAY_OF_WEEK_LOADING: {
      return state.set('isLoading', action.payload);
    }
    case actionTypes.CLEAR_DS_TOTAL_BY_DAY_OF_WEEK: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export default daySheetTotalByDayOfWeekReducer;
